import { extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import * as React from 'react';

const SvgQa48Rounded = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  "aria-label": "Qatar",
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#e7e7e7",
  d: "M12 22A10 10 0 1 0 2 12a10 10 0 0 0 10 10z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M12 22A10 10 0 1 0 2 12a10 10 0 0 0 10 10"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M8.89 21.51 11.14 12 8.88 2.5a10 10 0 0 0 0 19z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#751a46",
  d: "M22 12a10 10 0 0 1-15.32 8.47l2.2-.94-3-1.25 3-1.26-3-1.25 3-1.26-3-1.26 3-1.25-3-1.26 3-1.26-3-1.25 3-1.23-3-1.25 3-1.26-2.2-.93A10 10 0 0 1 22 12"
}));

export { SvgQa48Rounded as default };
//# sourceMappingURL=Qa48Rounded.js.map
